/** Returns exact match of target and it's index if exact match is found. Otherwise undefined and index of next date bigger than target. */
export function binarySearch(values: number[], target: number): [number | undefined, number] {
  let left: number = 0;
  let right: number = values.length - 1;

  while (left <= right) {
    const mid: number = Math.floor((left + right) / 2);

    if (values[mid] === target) {
      return [values[mid], mid];
    }
    target < values[mid] ? (right = mid - 1) : (left = mid + 1);
  }

  return [undefined, left];
}
